import React from 'react';
import './Footer.scss';
import logo from '../../logo.png';

const Footer = () => {

    return (
    <footer>
        <section className="footer">
            <div className="footer__site-info">
				<img className="footer__logo" src={logo} alt="logo" />
                <div className="footer__title" >Kalihackz</div>
            </div>
            <div className="footer__menu">
				<div className="footer__item">
					<div className="coding__title">Coding</div>
					<div className="coding__value">Github</div>
				</div>
				<div className="footer__item">
					<div className="social__title">Social Media</div>
					<div className="social__value">Facebook</div>
					<div className="social__value">Twitter</div>
					<div className="social__value">Instagram</div>
					<div className="social__value">Telegram</div>
					<div className="social__value">Discord</div>
				</div>
				<div className="footer__item">
					<div className="jobs__title">Jobs Portal</div>
					<div className="jobs__value">Linked In</div>
				</div>
            </div>
        </section>
    </footer>
    );

}

export default Footer;